<template>
  <div class="bg-white">

    <NavBar :user="user"/>

    <MiddleBarStaticPages title="Metody płatności"/>

    <div class="container pt-4">

      <div class="p-3">

        <p>
          <B>Klient może wybrać następujące formy płatności za zamówione towary i usługi:</B><br/>

          - Płatności BLIK<br/>
          - Karta płatnicza<br/>
          - Przelew elektroniczny poprzez zewnętrzny system płatności imoje, obsługiwany przez firmę ING Bank Śląski S.A. z siedzibą w Katowicach.<br/>
          - PayPal<br/>
          - PayU<br/>

          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
        </p>

      </div>

    </div>

    <Footer/>
  </div>
</template>

<script>
import MiddleBarStaticPages from '../../../elements/MiddleBarStaticPages';
import Footer from '../../../elements/Footer';
import NavBar from "@/elements/Navbar/index.vue";

export default {
  name: 'MetodyPlatnosci',
  components: {
    NavBar,
    MiddleBarStaticPages,
    Footer
  },
  data() {
    return {
      user: {
        id: null,
        permissions: []
      }
    }
  },

  created() {

    this.axios.get(window.API_URL + "user", { withCredentials: true }).then((response) => {

      let data = response.data

      if (data.userId) {

        this.user.id = data.userId
        this.user.permissions = data.permissions

      }

    });

    window.scrollTo({ top: 0, left: 0 });

  },
}
</script>

 